import { IOrgsRedux, CurrentRouteActionTypes, ROUTE_PATH, SET_CURRENT_ORG, SET_ORG_LIST, SET_THEME, SET_ORG_PERMISSIONS } from "./types";

const initialState: IOrgsRedux = {
    selectedOrg: {
        id : '',
        orgName : '',
        owner: ''
    },
    orgList: [],
    selectedTheme: {},
    orgPermissions: []
}
  

export function orgReducer(
    state =  initialState,
    action: CurrentRouteActionTypes
): IOrgsRedux {
    switch (action.type) {
        case ROUTE_PATH:
        case SET_CURRENT_ORG:
          return {
              ...state,
              selectedOrg: action.data.selectedOrg
          }
        case SET_ORG_LIST:
            return {
                ...state,
                orgList: action.data.orgList
            }
        case SET_THEME:
            return {
                ...state,
                selectedTheme: action.data
            }
        case SET_ORG_PERMISSIONS:
            return {
                ...state,
                orgPermissions: action.data.orgPermissions
            }
        default:
          return state
      }
}
